/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import { PureComponent } from 'react'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

class ActionLink extends PureComponent {
  onClick = () => {
    const { onClickActionLink } = this.props
    onClickActionLink()
  }

  render() {
    const { className, label, isStandalone } = this.props

    return (
      <ThemeProvider theme={theme}>
        <ActionLinkWrapper className={className} {...this.props}>
          {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
          {/** biome-ignore lint/a11y/useAriaPropsSupportedByRole: TODO */}
          {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
          <span
            className={isStandalone ? 'actionLinkStandalone' : 'actionLink'}
            onClick={this.onClick}
            aria-label={label}
          >
            {label}
          </span>
        </ActionLinkWrapper>
      </ThemeProvider>
    )
  }
}

ActionLink.defaultProps = {
  className: '',
  label: '',
  onClickActionLink: () => {},
  isDisabled: false,
  withBorder: false,
  isStandalone: false,
}

const ActionLinkWrapper = styled.div`
  .actionLinkStandalone {
    color: #009ade;
    font-size: ${theme.typography.fontSizeSm};
    cursor: pointer;
    font-weight: ${props => props.theme.typography.fontWeightBolder};
  }

  .actionLink {
    color: ${props => props.theme.palette.primary.main};
    font-size: ${theme.typography.fontSizeSm};
    float: right;
    cursor: pointer;
    font-weight: ${props => props.theme.typography.fontWeightBolder};
  }

  .actionLinkInline {
    color: ${props => props.theme.palette.primary.main};
    font-size: ${theme.typography.fontSizeSm};
    float: right;
    padding-top: 8px;
  }
`

export default ActionLink
